import { SvgIcon } from "@mui/material";

export const TimeClockCircle = (props: any) => {
  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.5 15.9375C12.6076 15.9375 15.9375 12.6076 15.9375 8.5C15.9375 4.39238 12.6076 1.0625 8.5 1.0625C4.39238 1.0625 1.0625 4.39238 1.0625 8.5C1.0625 12.6076 4.39238 15.9375 8.5 15.9375Z"
          stroke="currentColor"
          strokeWidth="1.0625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 8.5V5.84375"
          stroke="currentColor"
          strokeWidth="1.0625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.5 8.5L11.82 11.8207"
          stroke="currentColor"
          strokeWidth="1.0625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};
